import { render, staticRenderFns } from "./ShipDagmarAaenLivestreamWidget.vue?vue&type=template&id=715f97ec&scoped=true"
import script from "./ShipDagmarAaenLivestreamWidget.vue?vue&type=script&lang=js"
export * from "./ShipDagmarAaenLivestreamWidget.vue?vue&type=script&lang=js"
import style0 from "./ShipDagmarAaenLivestreamWidget.vue?vue&type=style&index=0&id=715f97ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "715f97ec",
  null
  
)

export default component.exports